export const profileFormTypes = {
  NAME: 'name',
  BIRTHDATE: 'birth-date'
}
